import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { User } from '../../types/user';
import { Media } from '../../types/media';

interface UserState {
  uid: string | null;
  email: string | null;
  displayName: string | null;
  photoURL: string | null;
  isAdmin: boolean;
  watchlist: Media[];
  settings: {
    notifications?: boolean;
    language?: string;
    emailPreferences?: {
      newsletter?: boolean;
      updates?: boolean;
    };
  };
}

const initialState: UserState = {
  uid: null,
  email: null,
  displayName: null,
  photoURL: null,
  isAdmin: false,
  watchlist: [],
  settings: {}
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<User | null>) => {
      if (action.payload) {
        state.uid = action.payload.uid;
        state.email = action.payload.email;
        state.displayName = action.payload.displayName;
        state.photoURL = action.payload.photoURL;
        state.isAdmin = action.payload.isAdmin;
        state.settings = action.payload.settings;
        state.watchlist = action.payload.watchlist;
      } else {
        return initialState;
      }
    },
    setWatchlist: (state, action: PayloadAction<Media[]>) => {
      state.watchlist = action.payload;
    },
    updateSettings: (state, action: PayloadAction<Partial<UserState['settings']>>) => {
      state.settings = { ...state.settings, ...action.payload };
    },
    clearUser: () => initialState
  }
});

export const { setUser, setWatchlist, updateSettings, clearUser } = userSlice.actions;
export default userSlice.reducer;
